<!-- Button to toggle visibility -->
<button
  class="show-columns-button"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  aria-label="Show/hide columns">
  Show Columns ({{ getVisibleColumnsCount() }})
  <mat-icon>arrow_drop_down</mat-icon>
</button>

<!-- Custom dropdown content -->
<mat-menu #menu="matMenu">
  <div class="custom-dropdown">
    <!-- Quick Actions -->
    <div class="quick-actions">
      <button mat-menu-item (click)="showDefaultColumns()">
        <span class="button-label">See Default</span>
      </button>
      <button mat-menu-item (click)="showAllColumns()">
        <span class="button-label">Show All</span>
      </button>
    </div>

    <!-- Column Checkboxes -->
    @for (column of columns?.value; track $index) {
      <div mat-menu-item>
        <mat-checkbox color="primary" [checked]="column.isVisible" (click)="$event.stopPropagation(); toggleColumnVisibility(column)">
          {{ column.label }}
        </mat-checkbox>
      </div>
    }
  </div>
</mat-menu>
